import { Route, Routes } from "react-router-dom";
import { useShowReload, useWindowOpener } from "../services/hooks";
import Page from "../webPage";
import Login from "../Components/Login";
import UserManagement from "../Components/Users";
import DeviceManagement from "../Components/Device/Device";
import PrivateRoute from "./PrivateRoute";
import Layout from "../Components/Layout/Layout";
import AddDeviceForm from "../Components/Device/AddDeviceForm";
import Company from "../Components/Company/Company";
import AddCompany from "../Components/Company/AddCompany";
import TagManagement from "../Components/Tags/Tags";
import VehicleManagement from "../Components/Vehicle/Vehicle";
import SupplierManagement from "../Components/Supplier/Supplier";
import ProductTypes from "../Components/Product/Products";
import ProductCategories from "../Components/Product/ProductCategories";
import "../App.css";
import "../Static/dashboard.css";
import PublicRoute from "./PublicRoute";
import Checkpoint from "../Components/Checkpoint/Checkpoint";
import Roles from "../Components/Role/Roles";
import LoadScreen from "../Components/Layout/LoadScreen";
import NotAuthorized from "../Components/Login/NotAuthorized";
import NotFound from "../Components/Login/NotFound";
import Welcome from "../Components/Layout/WelcomeScreen";
import Report from "../Components/Reports/Report";
// import Dashboard from "../Components/Dashboard/Dashboard";
import CheckpointIndex from "../Components/CreateCheckpoint";
import WorkFlowIndex from "../Components/workFlow";
import CreateTemplate from "../Components/Dynamic/CreateTemplate";
import VehicleMasterIndex from "../Components/VehicleMaster";
// import OffLineIndex from "../Components/Offline";
import TripIndex from "../Components/Trip";
import ApprovalIndex from "../Components/Approval";
import CheckpointTypes from "../Components/CheckpointTypes/CheckpointTypes";
import NewDashboard from "../Components/Dashboard";
import TagMappingIndex from "../Components/TagMapping";
import DynamicModule from "../Components/DynamicModule/DynamicModule";
import DynamicModuleCreater from "../Components/DynamicModule/DynamicModuleCreater";
import ApprovalConfigIndex from "../Components/ApprovalConfig";
import DeviceLogs from "../Components/Device/DeviceLogs";
import Settings from "../Components/Settings/Settings";
import AddWorkflowForm from "../Components/workFlow/AddWorkflowForm";
import MapView from "../Components/MapView";
import DriverMaster from "../Components/DriverMaster";
import CompanyStats from "../Components/Dashboard/CompanyStats";
import Analytics from "../Components/Analytics/Analytics";
import ThirdPartyLogs from "../Components/ApiLogs/ThirdPartyLogs";
import RuleManagement from "../Components/Settings/RuleManagement";
import Plant from "../Components/Plant/Plant";
import AddPlant from "../Components/Plant/AddPlant";
import CreateCheckpoint from "../Components/CreateCheckpoint/CreateCheckpoint";
import AddUser from "../Components/Users/AddUser";
import { SideBarItemsProvider } from "../context/sidebarContext";
import AddUserForm from "../Components/Users/AddUserForm";
import VehicleMovementStats from "../Components/VehicleMovementStats";
import DeviceMap from "../Components/DeviceMap/DeviceMap";
import Resources from "../Components/Resources/Resources";
import { useLayoutEffect } from "react";
import AllTrips from "../Components/AllTrips/AllTrips";

export default function AppRoutes() {
	useWindowOpener();
	useShowReload();
	const isURLWhiteLabel = !(window.location.hostname.includes("lynkid") || window.location.hostname.includes("localhost"));

	useLayoutEffect(() => {
		const url = new URL(window.location.href);
		const token = url.searchParams.get("token");
		const redirectPath = url.searchParams.get("redirectPath");
		if (token && !localStorage.getItem("secretkey")) {
			localStorage.setItem("secretkey", token);
			if (redirectPath) {
				window.location.replace(redirectPath);
			} else {
				window.location.reload();
			}
		}
	}, []);

	return (
		<Routes>
			<Route path="/" element={isURLWhiteLabel ? <Login /> : <Page />} />
			<Route element={<PublicRoute />}>
				<Route path="login" element={<Login />} />
			</Route>
			<Route element={<PrivateRoute />}>
				<Route
					element={
						<SideBarItemsProvider>
							<Layout />
						</SideBarItemsProvider>
					}
				>
					<Route path="vehicle-movement-stats" element={<VehicleMovementStats />} />
					<Route path="dashboard" element={<NewDashboard />} />
					<Route path="users" element={<UserManagement />} />
					<Route path="users/add-user" element={<AddUser />} />
					<Route path="users/edit-user-form" element={<AddUserForm />} />
					<Route path="users/add-user-form" element={<AddUserForm />} />
					<Route path="roles" element={<Roles />} />
					<Route path="companies" element={<Company />} />
					<Route path="companies/add-company" element={<AddCompany />} />
					<Route path="companies/edit-company" element={<AddCompany />} />
					<Route path="devices" element={<DeviceManagement />} />
					<Route path="devices/add-device" element={<AddDeviceForm />} />
					<Route path="devices/edit-device" element={<AddDeviceForm />} />
					{/* <Route path="devices/logs" element={<DeviceLogs />} /> */}
					<Route path="products" element={<ProductTypes />} />
					<Route path="product-categories" element={<ProductCategories />} />
					<Route path="tags" element={<TagManagement />} />
					<Route path="stray-tags" element={<TagMappingIndex />} />
					<Route path="suppliers" element={<SupplierManagement />} />
					<Route path="vehicles" element={<VehicleManagement />} />
					<Route path="reports" element={<Report />} />
					<Route path="checkpoints/:type/:number" element={<Checkpoint />} />
					<Route path="checkpoints" element={<CheckpointIndex />} />
					<Route path="checkpoints/add-checkpoint" element={<CreateCheckpoint />} />
					<Route path="checkpoints/edit-checkpoint" element={<CreateCheckpoint />} />
					<Route path="checkpoint-types" element={<CheckpointTypes />} />
					<Route path="workFlow" element={<WorkFlowIndex />} />
					<Route path="add-workflow" element={<AddWorkflowForm />} />
					<Route path="edit-workflow" element={<AddWorkflowForm />} />
					<Route path="loading" element={<LoadScreen />} />
					<Route path="welcome" element={<Welcome />} />
					<Route path="manage-trip" element={<TripIndex />} />
					<Route path="map-view" element={<MapView />} />

					<Route path="templates" element={<CreateTemplate />} />
					<Route path="create-template" element={<CreateTemplate />} />
					<Route path="vehicle-master" element={<VehicleMasterIndex />} />
					<Route path="driver-master" element={<DriverMaster />} />

					{/* <Route path="offline" element={<OffLineIndex />} /> */}
					<Route path="approval-management" element={<ApprovalIndex />} />
					<Route path="approval-configuration" element={<ApprovalConfigIndex />} />
					<Route path="dynamic-module" element={<DynamicModuleCreater />} />
					<Route path="module/:name" element={<DynamicModule />} />
					<Route path="settings" element={<Settings />} />
					<Route path="company-stats" element={<CompanyStats />} />
					<Route path="analytics" element={<Analytics />} />
					<Route path="third-party-logs" element={<ThirdPartyLogs />} />
					<Route path="rule-management" element={<RuleManagement />} />
					<Route path="plants" element={<Plant />} />
					<Route path="plants/add-plant" element={<AddPlant />} />
					<Route path="plants/edit-plant" element={<AddPlant />} />
					<Route path="device-map" element={<DeviceMap />} />
					<Route path="resources" element={<Resources />} />
					<Route path="allTrips" element={<AllTrips />} />
				</Route>
				<Route path="/not-authorized" element={<NotAuthorized />} />
				<Route path="*" element={<NotFound />} />
			</Route>
		</Routes>
	);
}
